import React, { useMemo } from "react";
import _ from "lodash";
import moment from "moment";
import Table from "../../../layout/Table";

const makeColumns = (columnNames) => {
  return columnNames.map((columnName) => ({
    Header: columnName,
    accessor: _.camelCase(columnName),
  }));
};

const formatDate = (date) => {
  if (!date) return "-";

  const md = moment(date);

  if (!md.isValid()) {
    console.error(`date is not valid`, date);
    return "ERROR";
  }

  return (
    <>
      {md.format("YYYY-MM-DD ddd")}
      <br />
      {md.format("h:mm:ss a")}
    </>
  );
};

const makeData = (schedules) => {
  const data = [];
  if (schedules) {
    Object.keys(schedules).forEach((id) => {
      const schedule = schedules[id];
      if (schedule)
        data.push({
          id,
          type: schedule.objType === "RemoteTemplate" ? "template" : "source",
          interval: schedule.interval,
          runDate: formatDate(schedule.runDate),
          endDate: formatDate(schedule.endDate),
        });
    });
  }
  return data;
};

export default function AdminRemoteSchedulesTable({ schedules }) {
  const columns = useMemo(
    () => makeColumns(["Id", "Type", "Interval", "RunDate", "EndDate"]),
    []
  );
  const data = useMemo(() => makeData(schedules), [schedules]);

  return (
    <>
      <h2>Schedules</h2>
      <Table data={data} columns={columns} />
    </>
  );
}
